export const SET_USER_ACTIVATION_SUCCESS = 'SET_USER_ACTIVATION_SUCCESS';
export const SET_USER_ACTIVATION_ERRORS = 'SET_USER_ACTIVATION_ERRORS';
